import { render } from "./the-home-page.vue?vue&type=template&id=6064cd69&scoped=true&bindings={\"roomKey\":\"setup\",\"link\":\"setup\",\"noRoomSelected\":\"setup\",\"gotoButton\":\"setup\",\"gotoRoom\":\"setup\"}"
import script from "./the-home-page.vue?vue&type=script&lang=js"
export * from "./the-home-page.vue?vue&type=script&lang=js"

import "./the-home-page.vue?vue&type=style&index=0&id=6064cd69&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6064cd69"

export default script